import { getMetricFromResidentialLevels as t } from "../index6.js";
import { getLevelNetFacadeArea as r } from "../level-metrics/index24.js";
const o = (e) => t(e, r);
export {
  o as getResidentialNetFacadeArea
};
//# sourceMappingURL=index50.js.map
